import React, { useEffect, useState, useRef} from 'react';

import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';
import CustomSelect from '../../components/custom-select/CustomSelect';
import LoadingScreen from 'react-loading-screen';
import DatePicker, { registerLocale } from "react-datepicker";
import { useReactToPrint } from 'react-to-print';

import WorkOrderModalWithDatatable from '../workOrder/WorkOrderModalWithDatatable';
import DocumentModalWithDatatable from '../document/DocumentModalWithDatatable';
import DocumentWarehouseItem from './DocumentWarehouseItem';

import DocumentPrint from '../document/DocumentPrint';
import { Page, Document, Image, StyleSheet } from '@react-pdf/renderer';
import * as Invoice from '../reports/DocumentPrintTemplate1';

const WarehouseDocumentWarehouseTab = (props) => {

    
    const [t] = useTranslation();           
    const [entitySubName, setEntitySubName] = useState("warehouse");
    const [entitySpecify, setEntitySpecify] = useState("ISS-WO");  
    const [entitySpecifyForInvoice, setEntitySpecifyForInvoice] = useState("");  
     
  //  const [warehouseDocument, setWarehouseDocument] = useState();             
    const [itemList, setItemList] = useState([]);
    const [itemBomList, setItemBomList] = useState([]);
  //  const [checkTime, setCheckTime] = useState([]);    
    const [transactionType, setTransactionType] = useState(null);
    const [showWorkOrderModalWithDatatable, setShowWorkOrderModalWithDatatable] = useState(false);
    const [showInvoiceModalWithDatatable, setShowInvoiceModalWithDatatable] = useState(false);
    const [loading , setLoading] = useState(false);
    const [workOrder, setWorkOrder] = useState();   
    const [workOrderId, setWorkOrderId] = useState(null);  
    const [invoice, setInvoice] = useState();   
    const [invoiceId, setInvoiceId] = useState(null);   
    const [warehouseList, setWarehouseList] = useState([]);
    const [warehouseIssId, setWarehouseIssId] = useState(null);
    const [warehouseRctId, setWarehouseRctId] = useState(null);
    const [bomId, setBomId] = useState(null);
    const [document, setDocument] = useState();     
    const [articlePartList, setArticlePartList] = useState();     
    const [showWarehouseIss, setShowWarehouseIss] = useState(false);    
    const [showWarehouseRct, setShowWarehouseRct] = useState(false);    
    const [showOrderField, setShowOrderField] = useState(false);   
    const [showInvoiceField, setShowInvoiceField] = useState(false);   
    
    const [showTransactionType, setShowTransactionType] = useState(false);    
    const [checkTime, setCheckTime] = useState(Date.now());    
    const [articlesCount, setArticlesCount] = useState(false);  
    
    const componentRef = useRef(null);
    
    const [transactionOptions, setTransactionOptions] = useState([]); 
 //   const [visibleWorkOrderNbr, setVisibleWorkOrderNbr] = useState(false);
    const [documentDate2, setDocumentDate2] = useState(Date.now());
    
    const transactionOptionsWrhRct = [   
  //   { value: 'RCT-WO', label: t('warehouse.label.RCT-WO') },
     { value: 'RCT-PO', label: t('warehouse.label.RCT-PO') },          
     { value: 'RCT-WO', label: t('warehouse.label.RCT-WO') }           
    
     
   ];

    const transactionOptionsWrhIss = [   
   //   { value: 'RCT-WO', label: t('warehouse.label.RCT-WO') },
      { value: 'ISS-SO', label: t('warehouse.label.ISS-SO') },          
      { value: 'ISS-WO', label: t('warehouse.label.ISS-WO') },           
      { value: 'ISS-UNP', label: t('warehouse.label.ISS-UNP') }           
      
      
    ];

    const transactionOptionsWrhMvm = [   
      //   { value: 'RCT-WO', label: t('warehouse.label.RCT-WO') },
         { value: 'ISS-TR', label: t('warehouse.label.ISS-TR') },          
         { value: 'RCT-TR', label: t('warehouse.label.RCT-TR') }           
        
         
      ];
  
    const emptyItem = {    
      lineNumber: 0,
      active: true, 
      itemId: '',
      itemName: '',
      qty: 0,
      posQty: 0,
      um: '',
      serialNumber: '' ,
      serialNumberEnabled: 0        
    };

    const openInvoiceModalWithDatatable = () => {
      setCheckTime(Date.now());
      setShowInvoiceModalWithDatatable(true);    
    }

    const openWorkOrderModalWithDatatable = () => {
      setShowWorkOrderModalWithDatatable(true);    
    }

    const handleCallbackWorkOrderModalWithDatatable = (show,id) => {               
      setShowWorkOrderModalWithDatatable(false);             
      getWorkOrder(id);
    };

    const handleCallbackInvoiceModalWithDatatable = (show,id) => {               
      setShowInvoiceModalWithDatatable(false);             
      getInvoice(id);
    };


    const getInvoice = (id) => {
      RestService.callAnyApi('document/getDocumentById?id='+id, null)
      .then((data) => {
        formik.setFieldValue('invoiceNbr',data.invoiceNbr); 
        setInvoiceId(data.id);
      })
    };


  

    const getWorkOrder = (id) => {
      setLoading(true);
      setArticlesCount(0);
      RestService.callAnyApi('workOrder/getWorkOrder?id='+id, null)
      .then((data) => {
        setWorkOrder(data); 
        setWorkOrderId(data.id);
        if(transactionType==='ISS-WO'){
            if(data && data.wrRouteTemplate && data.wrRouteTemplate.bom && data.wrRouteTemplate.bom.articlePartList){
              setBomId(data.wrRouteTemplate.bom.id);
             // setDocumentDate2(data.openDate);
              let x=0;
              data.wrRouteTemplate.bom.articlePartList.map((item,index) => {
                setItemList((itemList) => [
                  ...itemList,
                  {
                    lineNumber: x,
                    active: false, 
                    itemId: item.articlePart ? item.articlePart.id : '',
                    itemName: item.articlePart ? item.articlePart.name : '',
                    qty: item.qty*data.qtyOrd,
                    um: item.articlePart ? item.articlePart.measureUnit : '',                    
                    serialNumber: item.serialNumber ? item.serialNumber : '',
                    serialNumberEnabled:  item.serialNumberEnabled ? item.serialNumberEnabled : 0,
                  //  posQty: getWarehouseStatusByArticle(warehouseIssId,item.articlePart.id)
                  },
                ]);
              
                  x++;
                });
                setArticlesCount(x);
            }

        }   
        if(transactionType==='RCT-WO'){
          setBomId('');
          let x=0;
          let qtyOrd=0;
          let cycle=1;

            if(data && data.qtyOrd){
              qtyOrd= data.qtyOrd;
            }
            if(data.article && data.article.serialNumber===1){
              cycle=1; //qtyOrd;
              qtyOrd=1;
            }
            
            for(let x=0;x<cycle;x++){

                  setItemList((itemList) => [
                    ...itemList,
                    {
                      lineNumber: x,
                      active: false, 
                      itemId: data.articleId ? data.articleId : '',
                      itemName: data.article ? data.article.name : '',
                      qty: qtyOrd,
                      um: data.article ? data.article.measureUnit : '',                
                      serialNumberEnabled:  data.article ? data.article.serialNumber : 0   
                    },
                  ]);
            }
          
          
          
        
        }
      //  console.log(itemBomList);
        formik.setFieldValue('workOrderNbr',data.nbr);  
        setLoading(false);     
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);     
      });
    }


    const loadDocument = () => {
      RestService.callAnyApi('document/getDocument?entitySubName='+entitySubName+"&entitySpecify="+entitySpecify+"&id="+props.selectedRecord, null)
      .then((data) => {
           formik.setFieldValue('invoiceNbr',''); 
           formik.setFieldValue('workOrderNbr',''); 
           setDocument(data);     
           setWorkOrderId(data.workOrderId);
           setInvoiceId(data.invoiceId);
           setDocumentDate2(data.documentDate2 ? data.documentDate2 : Date.now())
           data.documentLines ? setItemList(data.documentLines) : setItemList([]);
        //  if(data && data.transactionType){
              setTransactionType(data && data.transactionType ? data.transactionType : '');
         //  }
           setWarehouseIssId(data && data.warehouseIssId ? data.warehouseIssId : '');
           setWarehouseRctId(data && data.warehouseRctId ? data.warehouseRctId : '');
           
           
      })
      .catch((error) => {    
            toast.error(error);
      });
    }

    useEffect(() => {         
      loadDocument();
     
    
    }, [props.selectedRecord])

    

    useEffect(() => {         
      loadDocument();
     
    
    }, [entitySpecify])

    useEffect(() => {         
      setEntitySpecify(props.entitySpecify);      
      setShowTransactionType(false);
      setTransactionType(Date.now()+''); 
      switch(props.entitySpecify){
        case "WRH-RCT":
          setShowTransactionType(true);         
          setTransactionOptions(transactionOptionsWrhRct);
        break;
        case "WRH-ISS":         
          setShowTransactionType(true);
          setTransactionOptions(transactionOptionsWrhIss);
        break;
        case "WRH-MVM":
        //  setTransactionOptions(transactionOptionsWrhMvm);
          setShowWarehouseIss(true);
          setShowWarehouseRct(true);
        break;
      }
      
      
    }, [props.entitySpecify])

    useEffect(() => {         
      loadDocument();
     
    
    }, [entitySubName])

    useEffect(() => {   
      if(document && document.id){

      }else{
        switch(props.entitySpecify){
          case "WRH-RCT":
               formik.setFieldValue('transactionType','RCT-WO'); 
          break;
          case "WRH-ISS":         
              formik.setFieldValue('transactionType','ISS-WO'); 
          default:
        }
        
      }
    
    }, [transactionOptions])    
    
  

    useEffect(() => {   
     
      if(articlesCount>0 && warehouseIssId!=null && itemList.length>0){ //&& bomId!=null 
            RestService.callAnyApi('warehouse/getWarehouseBomQty',{
                  
                    bomId: bomId,
                    warehouseId: warehouseIssId,            
                    documentLines: itemList
                })
                .then((data) => {                                                 
                            if(data.responseMessage==='OK'){
                                setItemList(data.responseObject.documentLines);                                                                                       
                            }else{
                                showError(null,data.responseMessage);
                            }                                  
                })
                .catch((error) => {               
                  showError(error,null);
                });
        }
    }, [articlesCount])

  
   useEffect(() => {   
    // console.log("bomList: "+itemBomList);
     //if(itemList.length===0){
      // setItemList(itemBomList);
      //}
    }, [itemBomList])
    
    useEffect(() => {      
      RestService.callAnyApi('warehouse/getWarehouseOptions', null).then((data) => { setWarehouseList(data);}).catch((error) => {});       
    }, []);

    const handleTransactionTypeChanged = (transactionType) => {      
        setTransactionType(transactionType);                 
    }

    useEffect(() => { 

      setShowWarehouseIss(false);
      setShowWarehouseRct(false);
      setShowOrderField(false);
      setShowInvoiceField(false);    
      setCheckTime(Date.now());
      formik.setFieldValue('transactionType',transactionType); 
      switch(transactionType){
        case "ISS-WO":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-ISS");
          setShowWarehouseIss(true);      
          setShowOrderField(true);                        
        break;
        case "ISS-SO":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-ISS");
          setEntitySpecifyForInvoice("INV-ISS");   
          setShowWarehouseIss(true);      
          setShowInvoiceField(true);    
        break;
        case "ISS-UNP":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-ISS");         
          setShowWarehouseIss(true);      
          setShowInvoiceField(false);    
        break;        
        case "RCT-WO":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-RCT");          
          setShowWarehouseRct(true);
          setShowOrderField(true);
        break;
        case "RCT-PO":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-RCT");          
          setEntitySpecifyForInvoice("INV-RCT");   
          setShowWarehouseRct(true);
          setShowInvoiceField(true);
        break;     
        case "ISS-TR":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-MVM");          
          setShowWarehouseIss(true);
          setShowWarehouseRct(true);          
        break;    
        case "RCT-TR":
          setEntitySubName("warehouse");
          setEntitySpecify("WRH-MVM");          
          setShowWarehouseIss(true);
          setShowWarehouseRct(true);          
        break; 
        default:
       //   setEntitySubName("warehouse");
       //   setEntitySpecify("WRH-ISS");
       //   setShowWarehouseIss(true);  
       //   setShowOrderField(true);
      }
    //  setItemList([]);
     // loadDocument();
     
    }, [transactionType])

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
         transactionType: document ? document.transactionType : '',
         warehouseIssId: document ? document.warehouseIssId : '',
         warehouseRctId: document ? document.warehouseRctId : '',
         documentText1: document ? document.documentText1 : '',
         workOrderNbr: document ? document.workOrderNbr : '',
         invoiceNbr: document ? document.invoiceNbr : ''
      },
      validationSchema: Yup.object({
      //   firstName: Yup.string()   
     //     .nullable()  
      //    .required(t('general.message.required')),
      
      }),
      onSubmit: (values) => {           
          save('document/saveDocument',values);         
      }
      
    });
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {


      
            if(transactionType==='RCT-WO' || transactionType==='RCT-PO'){
              if(values.warehouseRctId==null){
                showError(null,t('general.message.warehouseReceiveIsNotSelected'));
                return;
              }
            }
            if(transactionType==='ISS-WO'  || transactionType==='ISS-SO' || transactionType==='ISS-TR'  || transactionType==='ISS-UNP'){
              if(values.warehouseIssId==null){
                showError(null,t('general.message.warehouseIssueIsNotSelected'));
                return;
              }
            }
            if(transactionType==='RCT-TR'){
              if(values.warehouseRctId==null){
                showError(null,t('general.message.warehouseReceiveIsNotSelected'));
                return;
              }
              if(values.warehouseIssId==null){
                showError(null,t('general.message.warehouseIssueIsNotSelected'));
                return;
              }
            }

            document.partnerId = document.companyId;
            document.entitySubName=entitySubName;
            document.entitySpecify=entitySpecify;
            document.warehouseIssId = values.warehouseIssId;
            document.warehouseRctId = values.warehouseRctId;
            document.documentText1 = values.documentText1;          
            document.documentDescription1 = values.warehouseDocumentDescription1;
            document.documentDescription2 = values.warehouseDocumentDescription2;          
            document.documentLines = itemList;
            document.workOrderNbr = values.workOrderNbr;
            document.invoiceNbr = values.invoiceNbr;
            document.transactionType = transactionType;
            document.workOrderId = workOrderId;
            document.invoiceId = invoiceId;
            document.documentDate2 = documentDate2;


            RestService.callAnyApi(url,document)
                .then((data) => {                                                 
                            if(data.responseMessage==='OK'){
                                setDocument(data.responseObject); 
                                props.parentCallback(data.responseObject);
                                toast.success(t('general.message.saveSucceed'));                                                                      
                            }else{
                                showError(null,data.responseMessage);
                            }
                        
                      
                })
                .catch((error) => {               
                  showError(error,null);
                });
    }

   


    const clearForm = () => {
     
    }
    
    const addEmptyItem = () => {      
      itemList.map((item,index) => {
         if(item){
          item.active=false;
         }
      });
    //  console.log(itemList);
      emptyItem.lineNumber = itemList.length+1;
      //setArticlesCount(emptyItem.lineNumber);
      setItemList([...itemList, emptyItem]);
      
    }

    const itemCallback = (itemA,action) => {
       
       if(action==='edit'){
        itemList.map((item,index) => {
          if(itemA.lineNumber===item.lineNumber){
            //item = itemA;            
            item.active=true;
                                 
          }else{
            item.active=false;
          }
          
        });
      }

        if(action==='delete'){              
          const newList = itemList.filter((item) => item.lineNumber !== itemA.lineNumber);
          if(newList.length>0){
            setItemList(newList);
            
          }else{
            setItemList([]);            
          }
          
        }
        
        if(action==='copy'){
         
          itemList.map((item,index) => {           
              item.active=false;                      
          });
          const itemC = JSON.parse(JSON.stringify(itemA));
          itemC.lineNumber=itemList.length+1;
          itemC.active=true;        
          setItemList([...itemList,itemC]);
          
        }

        if(action!=='copy' && action!=='delete'){
          setItemList([...itemList]);        
        }
       
       // setActiveItem(index);
       return;
    }


 
    const getItems = itemList ? itemList.sort((a, b) => a.lineNumber > b.lineNumber ? 1 : -1).map((item,index) => {
    
      return (
      <DocumentWarehouseItem 
        parentCallback={itemCallback}
        item={item}        
        active={item ? item.active : false}
       // checkTime={checkTime}
       
      />
      )
    }) : null;
 
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
  
    

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
                      <form onSubmit={formik.handleSubmit}>     
                    

                      <LoadingScreen
    loading={loading}
    bgColor='#f1f1f1'
    spinnerColor='#9ee5f8'
    textColor='#676767'
   // logoSrc='/logo.png'
    text={t('general.message.pleaseWait')}
  >

                      <div className="row text-muted">                                  


                      <div class="col-3 col-sm-3 col-lg-3"  style={showTransactionType ? {  } : { display: 'none' }}>
                              <div class="form-group">
                                <label>{t('warehouse.label.transactionType')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=> {formik.setFieldValue('transactionType',value.value); handleTransactionTypeChanged(value.value);}}
                                      value={formik.values.transactionType}
                                      options={transactionOptions}     
                                />                                
                              </div>
                              {formik.touched.transactionType && formik.errors.transactionType ? (
                                <div style={{ color: 'red' }}>{formik.errors.transactionType}</div>
                              ) : null} 
                         </div>    

                       


                         <div className="col-2 col-sm-2 col-lg-2">
                                  <div className="form-group">
                                    <label>{t('warehouse.label.identification')}</label>
                                    <input type="text" class="form-control" readOnly placeholder="" {...formik.getFieldProps('documentText1')}  />
                                  </div>                                  
                          </div> 
   					  	          

                          <div class="col-2 col-sm-2 col-lg-2"  style={showWarehouseIss ? {  } : { display: 'none' }}>
                              <div class="form-group">
                                <label>{t('warehouse.label.warehouseIss')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=> {formik.setFieldValue('warehouseIssId',value.value); setWarehouseIssId(value.value)}}
                                      value={formik.values.warehouseIssId}
                                      options={warehouseList}      
                                />                                
                              </div>
                              {formik.touched.warehouseIssId && formik.errors.warehouseIssId ? (
                                <div style={{ color: 'red' }}>{formik.errors.warehouseIssId}</div>
                              ) : null} 
                         </div>    

                         <div class="col-2 col-sm-2 col-lg-2" style={showWarehouseRct ? {  } : { display: 'none' }}>
                              <div class="form-group">
                                <label>{t('warehouse.label.warehouseRct')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=> {formik.setFieldValue('warehouseRctId',value.value); setWarehouseRctId(value.value)}}
                                      value={formik.values.warehouseRctId}
                                      options={warehouseList}      
                                />                                
                              </div>
                              {formik.touched.warehouseId && formik.errors.warehouseId ? (
                                <div style={{ color: 'red' }}>{formik.errors.warehouseId}</div>
                              ) : null} 
                         </div>    


                        


                         <div className="col-2 col-sm-2 col-lg-2"  style={showOrderField ? {  } : { display: 'none' }}>
    					  	  					                                                         
                                    <label  style={{marginright: '5px'}}>{t('workOrder.label.workOrder')}</label>   
                                    <div className="input-group mb-3 find-item">                                                              
                                        
                                          <div className="input-group-prepend">
                                               <span className="input-group-text"><i className="fa fa-search"></i></span>
                                          </div>                                                                                                                            
                                          <input type="text" className="form-control col-12 col-sm-12 col-lg-12" readOnly onClick={openWorkOrderModalWithDatatable}  {...formik.getFieldProps('workOrderNbr')} placeholder={t('document.label.find')} />
                                    </div>
                             
                        </div>

                        <div className="col-1 col-sm-1 col-lg-1" style={showOrderField ? {  } : { display: 'none' }}>
                                  <div className="form-group">
                                    <label>{t('workOrder.label.pcsOrd')}</label>
                                    <input type="text" class="form-control" readOnly placeholder="" value={workOrder ? workOrder.qtyOrd : 0} />
                                  </div>                                  
                        </div> 
   					  	        

                         <div className="col-2 col-sm-2 col-lg-2"  style={showInvoiceField ? {  } : { display: 'none' }}>
    					  	  					                                                         
                                 <label  style={{marginright: '5px'}}>{t('document.label.invoice')}</label>   
                                              <div className="input-group mb-3 find-item">                                                              
                                                                                
                                                     <div className="input-group-prepend">
                                                        <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                     </div>                                                                                                                            
                                                     <input type="text" className="form-control col-12 col-sm-12 col-lg-12" readOnly onClick={openInvoiceModalWithDatatable}  {...formik.getFieldProps('invoiceNbr')} placeholder={t('document.label.find')} />
                                              </div>
                                                                                
                        </div>
                      
                      </div>

    					        <div className="row text-muted">
                          <div class="col-3 col-sm-3 col-lg-3">
                                <div class="form-group">
                                  <label style={{marginRight: '5px'}}>{t('document.label.effectiveDate')}: </label>                              
                                  <DatePicker
                                        className='form-control'                                       
                                        selected={documentDate2}
                                        onChange={(value) => setDocumentDate2(new Date(value).getTime())}
                                        dateFormat="dd.MM.yyyy"                                                                              
                                  /> 
                                </div>  
                          </div>    
                      </div>

    					        <div className="row text-muted">
    					  	  
		    					          	<div className="col-6 col-sm-6 col-lg-6">
    					  	  		          <input type="text" className="form-control col-12 col-sm-12 col-lg-12" {...formik.getFieldProps('warehouseDocumentDescription1')}  placeholder={t('document.label.upperDescription')} />
    					  	  		      </div>    					  	  		
                			</div>

    					  	
    					  	    <div className="row text-muted" style={{marginLeft: '1px', marginRight: '1px', marginTop: '5px', fontSize: '13px', backgroundColor: '#e3e3e3', borderRadius: '5px'}}>
    					  	 
    					  	  	    	<div className="col-5 col-sm-5 col-lg-5">{t('document.label.item')}</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1">{t('warehouse.label.reqQty')}</div>
                            <div className="col-1 col-sm-1 col-lg-1">{t('warehouse.label.posQty')}</div>
    					  	  		    <div className="col-1 col-sm-1 col-lg-1">{t('document.label.um')}</div>
    					  	  		    <div className="col-3 col-sm-3 col-lg-3">{t('article.label.sn')}</div>    					  	  		    
                            <div className="col-1 col-sm-1 col-lg-1">{t('document.label.actions')}</div> 
    					  	  		  
                			</div>

             
                			<div className="row text-muted" style={{marginTop: '5px'}}></div>
    					  	 
    					  	         
                                {getItems}                                 
                			     
    					  	  
                			<div className="row" style={{marginTop: '10px'}}>
    				              
                      	  	  	<div className="col-12 col-sm-12 col-lg-12">    					  	  		
                                      <button type="button" className="btn btn-default" onClick={addEmptyItem}><i className="fas fa-plus"></i></button>
    					  	  	          </div>

    					  	    </div>

    					  	            
    						      <div className="row text-muted" style={{marginTop: '10px',marginBottom: '20px'}}>
    					  	  
		    					  	          <div className="col-12 col-sm-12 col-lg-12" style={{paddingRight: '10px'}}>
    					  	  		            <input type="text" className="form-control col-12 col-sm-12 col-lg-12" {...formik.getFieldProps('warehouseDocumentDescription2')} placeholder={t('document.label.lowerDescription')} />
    					  	  		        </div>
                			</div>






                 







                      
                      
                        <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={clearForm}>{t('general.button.clearForm')}</Button>  
                            <Button className="btn-default float-right" onClick={handlePrint}>{t('general.button.print')}</Button>  
                            
                  			</div>


                        </LoadingScreen>
                      </form>
                      <WorkOrderModalWithDatatable 
                          parentCallback={handleCallbackWorkOrderModalWithDatatable}    
                          modal={showWorkOrderModalWithDatatable}                                
                      />
                       <DocumentModalWithDatatable 
                          parentCallback={handleCallbackInvoiceModalWithDatatable}    
                          modal={showInvoiceModalWithDatatable}     
                          entitySubName="invoice"                           
                          entitySpecify={entitySpecifyForInvoice}
                          checkTime={checkTime}
                      />
                      
                      <div style={{ display: "none" }}>
                          <DocumentPrint 
                            ref={componentRef}
                            document={document}
                       
                          />
                      </div>
               
        </div>
    );
};



export default WarehouseDocumentWarehouseTab;